/*
 * @Author: linguang linguang@nextmar.com
 * @Date: 2025-04-15 09:51:52
 * @LastEditors: linguang linguang@nextmar.com
 * @LastEditTime: 2025-04-15 17:07:20
 * @FilePath: /zeelool-nextjs/src/app/account/refer-a-friend/store/invite-friend-store.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { getSearchDataByType } from '@/api/public';
import logger from '@/utils/client-logger';
import { create } from 'zustand';

interface SearchState {
  // 搜索历史
  searchHistory: string[];
  setSearchHistory: (history: string[]) => void;

  // 搜索数据
  searchData: any;
  setSearchData: (data: any) => void;

  // 自动补全关键词数据
  keywordsMaps: any[];
  setKeywordsMaps: (data: any[]) => void;

  // 历史搜索商品列表
  historyProductList: any[];
  setHistoryProductList: (data: any[]) => void;
  refreshSearchHistory: () => Promise<void>;

  // 热门搜索商品列表
  hotProductList: any[];
  setHotProductList: (data: any[]) => void;

  // 点击词相关状态
  isClickWords: number;
  searchWordType: string;
  setIsClickWords: (value: number) => void;
  setSearchWordType: (type: string) => void;

  // 数据加载状态
  isSearchDataLoaded: boolean;
  isSearchDataLoading: boolean;
  setIsSearchDataLoaded: (loaded: boolean) => void;
  setIsSearchDataLoading: (loading: boolean) => void;
}

export const useSearchStore = create<SearchState>((set, get) => ({
  // 初始状态
  searchHistory: [],
  searchData: null,
  keywordsMaps: [],
  historyProductList: [],
  hotProductList: [],
  isClickWords: 0,
  searchWordType: '',
  searchValue: '',
  isSearchDataLoaded: false,
  isSearchDataLoading: false,

  // 设置方法
  setSearchHistory: async (history) => {
    if (history.length) {
      try {
        const response = await getSearchDataByType('history', {
          keywords: history,
          limit: 6,
        });

        if (response.code === 200 && response.data && Array.isArray(response.data)) {
          set({ historyProductList: response.data });
        }
      } catch (error) {
        logger.error('Failed to get history goods:', error);
      }
    } else {
      set({ historyProductList: [] });
    }
    set({ searchHistory: history });
    localStorage.setItem('zl-searchHistory', JSON.stringify(history));
  },
  refreshSearchHistory: async () => {
    const { searchHistory } = get();
    const response = await getSearchDataByType('history', {
      keywords: searchHistory,
      limit: 6,
    });
    if (response.code === 200 && response.data && Array.isArray(response.data)) {
      set({ historyProductList: response.data });
    }
  },
  setSearchData: (data) => set({ searchData: data }),
  setKeywordsMaps: (data) => set({ keywordsMaps: data }),
  setHistoryProductList: (data) => set({ historyProductList: data }),
  setHotProductList: (data) => set({ hotProductList: data }),
  setIsClickWords: (value) => set({ isClickWords: value }),
  setSearchWordType: (type) => set({ searchWordType: type }),
  setIsSearchDataLoaded: (loaded) => set({ isSearchDataLoaded: loaded }),
  setIsSearchDataLoading: (loading) => set({ isSearchDataLoading: loading }),
}));
